import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-crown",
  "use": "icon-crown-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-crown\"><path d=\"M12 3a1 1 0 00-.582 1.814L8.346 9.115 2.947 7.316a1 1 0 10-.73.658L4 16v4h16v-4l1.783-8.023A1 1 0 1021 7c0 .108.018.214.053.316l-5.399 1.8-3.074-4.303A1.001 1.001 0 0013 4a1 1 0 00-1-1zm0 4.441l2.025 2.836.86 1.204 1.4-.467 2.996-.998L18.397 14H5.604l-.885-3.986 2.994.998 1.4.466.86-1.2L12 7.44zM6 16h12v2H6v-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol